import { Button } from '#/modules/commonComponents/button';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import PurchaseAmendmentStatusBadge from '#/modules/srmMgmt/purchaseOrder/components/PurchaseAmendmentStatusBadge';
import { pickPurchaseAmendmentHistory } from '#/modules/srmMgmt/purchaseOrder/helper/purchaseAmendmentStatus';
import { formatDateTimeOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

/** Detail `amendments[]` 欄位（兩種採購單共用）：預覽、狀態、事由、時間。 */
export function buildPurchaseOrderAmendmentColumns({ onPreview } = {}) {
  return [
    {
      id: 'preview',
      header: '預覽',
      size: 88,
      enableSorting: false,
      cell: ({ row }) => (
        <Button type="button" size="sm" onClick={() => onPreview?.(row.original)}>
          預覽
        </Button>
      ),
    },
    {
      id: 'amendmentNo',
      header: '異動號',
      accessorFn: (row) => displayDash(row?.amendmentNo),
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.amendmentNo)} />
      ),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 110,
      enableSorting: false,
      meta: { statusPresentation: 'badge' },
      cell: ({ row }) => (
        row.original.status
          ? <PurchaseAmendmentStatusBadge status={row.original.status} size="sm" />
          : '—'
      ),
    },
    {
      id: 'issueReason',
      header: '事由',
      accessorFn: (row) => displayDash(row?.issueReason),
      size: 220,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.issueReason)} />
      ),
    },
    {
      id: 'remark',
      header: '備註',
      accessorFn: (row) => displayDash(row?.remark),
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.remark)} />
      ),
    },
    {
      id: 'submittedAt',
      header: '提交時間',
      accessorFn: (row) => formatDateTimeOrDash(pickPurchaseAmendmentHistory(row).submittedAt),
      size: 160,
      enableSorting: false,
    },
    {
      id: 'decidedAt',
      header: '核准／退回時間',
      accessorFn: (row) => {
        const history = pickPurchaseAmendmentHistory(row);
        return formatDateTimeOrDash(history.approvedAt ?? history.rejectedAt);
      },
      size: 160,
      enableSorting: false,
    },
  ];
}
